import Highcharts from "highcharts"

Highcharts.polarisTheme =
  time:
    timezoneOffset: new Date().getTimezoneOffset()
  chart: style:
    color: '#9BADBB'
    fontFamily: '-apple-system, "BlinkMacSystemFont", "San Francisco", "Roboto", "Segoe UI", "Helvetica Neue", sans-serif'
  tooltip:
    useHTML: true
    backgroundColor: '#111433'
    borderWidth: 0
    borderRadius: 8
    shadow: false
    style: color: '#ffffff'
  title: text: ''
  credits: enabled: false
  plotOptions: {}
  yAxis:
    title: 
      margin: 30
      style: color: "#9BADBB"
    labels: style: color: "#9BADBB"
  xAxis:
    labels: style: color: "#9BADBB"
  legend:
    verticalAlign: 'bottom'
    align: 'right'
    itemStyle: fontWeight: 400
  colors: [
    '#9c6ade'
    '#47c1bf'
    '#5c6ac4'
    '#50248F'
    '#eec200'
    '#C05717'
    '#DE3618'
    '#50B83C'
    '#108043'
    '#454F5B'
  ]

Highcharts.setOptions Highcharts.polarisTheme
